import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Collapse, Stack, Typography } from '@mui/material';

interface Props {
  sourceOptionLabel: string;
  targetOptionLabel: string;
  onApply: () => void;
}

export default function CopyInclusionsPrefillBar({ sourceOptionLabel, targetOptionLabel, onApply }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
      <Button
        fullWidth
        onClick={() => setOpen((current) => !current)}
        sx={{ justifyContent: 'flex-start', textTransform: 'none' }}
        endIcon={
          <ExpandMoreIcon
            sx={{ ml: 'auto', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 120ms' }}
          />
        }
      >
        → Copy inclusions from {sourceOptionLabel} as a starting point
      </Button>
      <Collapse in={open}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ p: 1.5, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary">
            This replaces all inclusions on {targetOptionLabel} with a copy of {sourceOptionLabel}.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              onApply();
              setOpen(false);
            }}
          >
            Apply
          </Button>
        </Stack>
      </Collapse>
    </Box>
  );
}
